import { storageSession } from '@/utils/storage';

export default {
  name: 'FirstOrderPromo',
  components: {},
  props: {},
  emits: [],
  data() {
    return {};
  },
  watch: {},
  created() {
    storageSession.setItem('firstOrderPromo', true);
  },
  mounted() {},
  computed: {},
  methods: {},
  unmounted() {}
};
